<template>
  <div>
    <interactive-text-designer
      :settingStyles="interactiveTextController.contents.settings.styles"
      :leftPanelsTop="leftPanelsTop"
      :leftPanelsBottom="leftPanelsBottom"
      :pageId="pageId">
    </interactive-text-designer>
  </div>
</template>

<script>
import InteractiveTextDesigner from "../interactiveText/components/InteractiveTextDesigner.vue"
import interactiveTextController from "../interactiveText/controllers/InteractiveTextController/index.js"
import OutlinePanel from "../interactiveText/components/OutlinePanel.vue"
import ObjectivePanel from "./components/ObjectivePanel.vue"
import Settings from "./components/Settings.vue"
import GlossaryPanel from "../commonInteractive/glossary/GlossaryPanel.vue"
import glossaryController from "../commonInteractive/glossary/GlossaryController"
import { RevisionDisplayMode } from "plant-common/src/models/revisionDisplayMode.js"
import { createOutlineNavigator } from "../commonInteractive/textEditor/controllers/outlineNavigatorFactory"
import { createHtmlFileSaver } from "../commonInteractive/textEditor/controllers/htmlFileSaverFactory"
import { createStyleSheetController } from "../commonInteractive/textEditor/controllers/styleSheetControllerFactory"

export default {
  name: "InteractiveBook",
  props: ["value", "view", "mode", "comments"],
  components: { InteractiveTextDesigner, Settings, GlossaryPanel },
  data() {
    return {
      interactiveTextController: interactiveTextController(this),
      outlineNavigator: createOutlineNavigator(),
      htmlFileSaver: createHtmlFileSaver(this),
      styleSheetController: createStyleSheetController(this)
    }
  },
  computed: {
    pageId() {
      return this.interactiveTextController.selectedPage ? this.interactiveTextController.selectedPage.id : "0"
    },
    leftPanelsBottom() {
      return [
        {
          title: "Interactive Book Settings",
          icon: "mdi-cog",
          component: Settings,
          disabled: this.interactiveTextController.mode !== RevisionDisplayMode.edit
        }
      ]
    },
    hasSomeGlossary() {
      return this.hasLocalGlossary() || this.hasImportedGlossary() || this.hasGlossaryFromInteractiveText()
    },
    leftPanelsTop() {
      const panels = [
        {
          title: "Outline",
          icon: "mdi-file-tree",
          component: OutlinePanel
        }
      ]

      if (this.mode === RevisionDisplayMode.edit || this.hasSomeGlossary) {
        panels.push(this.buildGlossaryPanelProps())
      }

      if (this.interactiveTextController.ibObjectives.length) {
        panels.push({
          title: "Objectives",
          icon: "mdi-bullseye-arrow",
          component: ObjectivePanel
        })
      }

      return panels
    }
  },
  methods: {
    hasLocalGlossary() {
      return this.value.body.contents.glossary && this.value.body.contents.glossary.length
    },
    hasImportedGlossary() {
      return this.value.body.contents.glossaryImported && this.value.body.contents.glossaryImported.length
    },
    hasGlossaryFromInteractiveText() {
      return this.interactiveTextController &&
          this.interactiveTextController.glossariesFromItsFromPage &&
          this.interactiveTextController.glossariesFromItsFromPage.length
    },
    getGlossariesFromInteractiveTexts() {
      return this.interactiveTextController.glossariesFromItsFromPage
    },
    buildGlossaryPanelProps() {
      return {
        title: "Glossary",
        icon: "mdi-book-alphabet",
        component: GlossaryPanel,
        props: {
          mode: this.mode,
          value: this.value,
          controller: glossaryController(this)
        }
      }
    }
  },
  provide() {
    return {
      controller: this.interactiveTextController,
      outlineNavigator: this.outlineNavigator,
      htmlFileSaver: this.htmlFileSaver,
      styleSheetController: this.styleSheetController
    }
  }
}
</script>

<style>
.it-index {
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
}

.it-index-panel {
  position: absolute;
  bottom: 0;
}

.it-index-main {
  position: absolute;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.it-page__add-page {
  flex: 1;
}

.it-page-wrapper {
  overflow: auto;
  padding: 20px 20px 40px;
}
</style>
